import axios from 'axios';

const client = axios.create({
    withCredentials: true,
});

async function getContent(props) {
    const { data } = await client.post('getContent', props);
    return data;
}
async function getCount(props) {
    const { data } = await client.post('getCount', props);
    return data;
}

const isRecord = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);
const isNullableString = (value) => value === null || typeof value === 'string';
const isRelatedEntry = (value) => isRecord(value)
    && typeof value.id === 'string'
    && isNullableString(value.title)
    && isNullableString(value.slug)
    && isNullableString(value.uri);
const isNewsEntry = (value) => isRecord(value)
    && typeof value.id === 'string'
    && isNullableString(value.title)
    && isNullableString(value.slug)
    && isNullableString(value.uri)
    && isNullableString(value.postDate)
    && Array.isArray(value.authorBlog)
    && value.authorBlog.every(isRelatedEntry)
    && Array.isArray(value.category)
    && value.category.every(isRelatedEntry)
    && Array.isArray(value.tags)
    && value.tags.every(isRelatedEntry);
const isNavigationEntry = (value) => isRecord(value)
    && typeof value.id === 'string'
    && isNullableString(value.title)
    && isNullableString(value.slug)
    && isNullableString(value.uri)
    && isNullableString(value.postDate)
    && Array.isArray(value.category)
    && value.category.every(isRelatedEntry);
function assertGetNewsResponse(value) {
    if (!isRecord(value)
        || !Array.isArray(value.entries)
        || !value.entries.every(isNewsEntry)
        || !Number.isInteger(value.total)
        || Number(value.total) < 0) {
        throw new TypeError('Invalid getNews response from middleware');
    }
}
function assertNavigationResponse(value) {
    if (!isRecord(value)
        || !(value.previous === null || isNavigationEntry(value.previous))
        || !(value.next === null || isNavigationEntry(value.next))) {
        throw new TypeError('Invalid getNewsNavigation response from middleware');
    }
}
async function getNews(params = {}) {
    const { data } = await client.post('getNews', params);
    assertGetNewsResponse(data);
    return data;
}
async function getNewsNavigation(params) {
    const { data } = await client.post('getNewsNavigation', params);
    assertNavigationResponse(data);
    return data;
}

var methods = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getContent: getContent,
    getCount: getCount,
    getNews: getNews,
    getNewsNavigation: getNewsNavigation
});

/**
 * Initialize the CraftCms connector.
 */
const craftCmsConnector = (options) => {
    client.defaults.baseURL = options.apiUrl;
    client.defaults.headers.common = options.headers;
    return methods;
};

/**
 * CraftCms module.
 */
const craftCmsModule = (options) => ({
    connector: craftCmsConnector({
        apiUrl: options.apiUrl,
        headers: options.headers,
    }),
    utils: {},
    subscribers: {},
});

export { client, craftCmsModule };
